import {Injectable} from "@angular/core";
import {CanActivate, Router} from "@angular/router";
import {ITagsWebServiceClient} from "app/common/resources/resources";
import { Observable } from "rxjs";

@Injectable()
export class UserAdminAuthGuard implements CanActivate {

  constructor(private iTagsWebServiceClient: ITagsWebServiceClient, private router: Router) {
  }

  canActivate() {
      return this.iTagsWebServiceClient.isFormulaireDematAdminEnabled().map(isAdmin => {
        if (isAdmin){
          return true;
        }
        else {
          this.router.navigate(['']);
          return false;
        }
      }).catch((e) => { 
        this.router.navigate(['/cerba/catalogue']);
        return Observable.of(e);
      });
  }
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/admin/admin.guard.ts